import { render, staticRenderFns } from "./specialText.vue?vue&type=template&id=0322b66d&scoped=true"
import script from "./specialText.vue?vue&type=script&lang=js"
export * from "./specialText.vue?vue&type=script&lang=js"
import style0 from "./specialText.vue?vue&type=style&index=0&id=0322b66d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0322b66d",
  null
  
)

export default component.exports